import classNames from 'classnames'
import type { FC } from 'react'
import React, { useMemo } from 'react'

import type { ContainerProps } from './types'
import { BoxPrivate } from '../../_primitives/box/box'

const Container: FC<ContainerProps> = React.forwardRef<
  HTMLDivElement,
  ContainerProps
>(function Container(props, ref) {
  const { variant: _variant, className, fillContainer, ...rest } = props
  const variant = _variant ? `container.${_variant}` : 'container'
  const __css = useMemo(
    () =>
      fillContainer
        ? {
            inset: 0,
            bottom: 0,
            left: 0,
            right: 0
          }
        : {
            width: '100%',
            minWidth: 0,
            mx: 'auto'
          },
    [fillContainer]
  )
  return (
    <BoxPrivate
      ref={ref}
      variant={variant}
      className={classNames(
        {
          'csg-tui-container': true
        },
        className
      )}
      relative={fillContainer ? false : true}
      absolute={fillContainer ? true : false}
      {...rest}
      __themeKey="layout"
      __css={__css}
    />
  )
})

export default Container
